module.exports = __webpack_public_path__ + "img/20220802_1.65cc30de.jpg";